import React from 'react';
import { Tooltip, Typography } from 'antd';
import {
  modalActionTypes,
  modalTypes,
  useModalDispatch,
} from '../../../../../shared/lib/toggleModalVisble';
import { useShutdownAccesses } from '../../../../../shared/lib/hooks/useShutdownAccesses';

const { Text } = Typography;

const ActiveType = ({ shutdown }) => {
  const dispatch = useModalDispatch();

  const handleClick = (e) => {
    e.stopPropagation();

    dispatch({
      type: modalActionTypes.setModalData,
      payload: {
        type: modalTypes.changeShutdownType,
        initialValues: shutdown,
      },
    });
  };

  return (
    <Tooltip
      title={shutdown.alertType ? 'Изменить' : 'Добавить'}
      placement="topLeft"
    >
      <Text onClick={handleClick}>
        {shutdown?.alertType?.name || 'Не указано'}
      </Text>
    </Tooltip>
  );
};

const Content = ({ shutdown }) => {
  const { canChange } = useShutdownAccesses();

  if (!canChange) {
    return <Text>{shutdown?.alertType?.name || 'Не указано'}</Text>;
  }

  return <ActiveType shutdown={shutdown} />;
};

export default Content;
